import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the GoogleMapsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GoogleMapsProvider {

  loaded: boolean = false;
  resolver = null;
  libCount = 2;
  loadedCount = 0;
  constructor(public http: HttpClient) {
    //AIzaSyBo1RzdWK8vjUtTFqO0vSWQCaEH7RrFe5A

    var me = this;
    (window as any).googleLoaded = () => {
      me.loadedCount++;
      if (me.loadedCount === me.libCount) {
        me.loaded = true;
        if (me.resolver !== null) {
          // @ts-ignore
          this.resolver(google)
        }
      }
    };

    let mapScript = document.createElement("script");
    mapScript.setAttribute("src", "https://maps.google.com/maps/api/js?key=AIzaSyBo1RzdWK8vjUtTFqO0vSWQCaEH7RrFe5A&libraries=geometry&callback=window.googleLoaded")
    let clusterScript = document.createElement("script")
    clusterScript.setAttribute("src", "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js")
    clusterScript.setAttribute("onload", "window.googleLoaded()");
    document.head.appendChild(clusterScript);
    document.head.appendChild(mapScript);

  }

  getGoogle(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.loaded) {
        // @ts-ignore
        resolve(google);
      } else {
        this.resolver = resolve;
      }
    });
  }

getLeaflet(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.loaded) {
        // @ts-ignore
        resolve(google);
      } else {
        this.resolver = resolve;
      }
    });
  }


}
